import{gql as e}from"@grandvisionhq/graphql";const t=e`
  query LatestDeliveryForEstimationItems($input: EstimatedDeliveryByEstimationItemsInput!) {
    latestDeliveryForEstimationItems(input: $input) {
      __typename
      ... on LatestDeliveryEstimationSuccessResponse {
        __typename
        result {
          shippingMethodKey
          earliestDeliveryDate
          latestDeliveryDate
        }
      }
      ... on DeliveryEstimationsFailureResponse {
        failures {
          ... on GenericEstimationFailure {
            message
          }
        }
      }
    }
  }
`;export{t as GET_LATEST_DELIVERY_FOR_ESTIMATION_ITEMS};
//# sourceMappingURL=latestDeliveryForEstimationItems.js.map
